import { render, staticRenderFns } from "./repairPage.vue?vue&type=template&id=798f7162&scoped=true&"
import script from "./repairPage.vue?vue&type=script&lang=js&"
export * from "./repairPage.vue?vue&type=script&lang=js&"
import style0 from "./repairPage.vue?vue&type=style&index=0&id=798f7162&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f7162",
  null
  
)

export default component.exports